import "./Influence.scss";

export default function Influence() {
  return (
    <section className="influence section" id="influence">
      <div className="section-header">
        <span className="section-eyebrow">The board becomes your engine</span>
        <h2 className="section-title">Brute Force or Surrounding Influence.</h2>
        <p className="section-copy">
          Large buildings can be conquered in more than one way. Pay the full warrior cost directly, or first claim connected buildings and use your growing influence to weaken the target.
        </p>
      </div>

      <div className="influence__compare">
        <article className="influence__method card influence__method--force">
          <div className="influence__icon">⚔</div>
          <h3>Brute Force</h3>
          <p>
            Gather all the required warriors and pay the full cost to conquer a building directly.
          </p>
        </article>

        <article className="influence__method card influence__method--influence">
          <div className="influence__icon">⚑</div>
          <h3>Surrounding Influence</h3>
          <p>
            Place flags on connected buildings around a target to reduce the number of warriors needed.
          </p>
        </article>
      </div>

      <div className="influence__story card">
        <div className="influence__board" style={{ backgroundImage: "url('/assets/images/influence.webp')" }}>
          {/* <div className="image-placeholder">
            <div>
              <strong>Influence Example</strong>
              <small>Replace: public/assets/images/influence.webp</small>
            </div>
          </div> */}
        </div>

        <div className="influence__steps">
          <div className="influence__step">
            <strong>1 Flag</strong>
            <p>One nearby building starts your position, but may not create enough influence yet.</p>
          </div>
          <div className="influence__step">
            <strong>2 Connected Flags</strong>
            <p>Your influence grows, reducing the warriors needed to take the target.</p>
          </div>
          <div className="influence__step">
            <strong>3 Connected Flags</strong>
            <p>The discount becomes stronger, turning earlier conquests into a powerful advantage.</p>
          </div>
        </div>
      </div>

      <p className="influence__takeaway">
        Every flag you place can open new opportunities around more than one building.
      </p>
    </section>
  );
}
